import dayjs from "dayjs"

const validBooleans: unknown[] = [0, 1, true, false, "true", "false"]
const trulyEntries: unknown[] = [1, "1", true, "true"]

export default {
  number: (value: unknown) => (!isNaN(Number(value))),
  string: (value: unknown) => (typeof value === "string" || value instanceof String),
  object: (value: unknown) => (typeof value === "object" && !Array.isArray(value) && value !== null),
  date: (value: unknown) => (value instanceof Date),
  boolean: (value: unknown) => validBooleans.includes(value),
  undefined: (value: unknown) => (typeof value === "undefined"),
  truly: (value: unknown) => (trulyEntries.includes(value)),
  dayjs: (value: unknown) => dayjs.isDayjs(value),
  array: (value: unknown) => Array.isArray(value)
}
